import React, { useEffect, useState } from "react";
import { IonContent, IonLoading, useIonToast } from "@ionic/react";
import styles from "./Css/PhysicalTake.module.scss";
import CustomHeader from '../../General/Components/CustomHeader';
import BackButton from '../../General/Components/BackButton';
import PhysicalTakeHeader from './Components/PhysicalTakeHeader';
import PhysicalTakeDetail from './Components/Detail/PhysicalTakeDetail';
import { openDataBase, allElements, deleteElement } from '../../Helper/Indexeddb';
import { helpContent } from './Data/Data';
import { updateAmountPhysicalTakeArray } from './Services';
import { closeCircle } from 'ionicons/icons';

function PhysicalTake() {
    const model = 'pyshicalTake';
    const [db, setDb] = useState(null);
    const [name, setName] = useState('Toma Física');
    const [state, setState] = useState('header');
    const [charge, setCharge] = useState(true);
    const [loading, setLoading] = useState(false);
    const [physicTakeHeaderCode, setPhysicTakeHeaderCode] = useState('');
     const [present] = useIonToast();

    useEffect(() => {
        sessionStorage.removeItem("articleGroups");
        sessionStorage.removeItem("areasByRestaurant");
        openDataBase().then((db) =>{setDb(db); updateElements(db);});
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (state === 'header') { updateElements(db);}
        // eslint-disable-next-line
    }, [state]);

    const updateElements = (connection) => {
        if(connection){
            allElements(connection, model).then(
                (response) => {
                    if(response.status && response.data.length > 0){
                        const data = response.data.map(item => item.value);
                        const keys = response.data.map(item => item.id);
                        setLoading(true);
                        updateAmountPhysicalTakeArray(data).then(
                            (result)=>{
                                setLoading(false);
                                if(result.status){
                                    deteletPhysicalTake(keys, connection);
                                } else if(result.offline){
                                    present({
                                        message: 'No se pudo guardar la información, puede seguir funcionando sin conexión y, una vez que se restaure la conexión a internet, se llevará a cabo el almacenamiento automático de la misma.',
                                        duration: 6000,
                                        position: 'bottom',
                                        color: 'secondary',
                                        icon: closeCircle
                                    })
                                }
                            }
                        )
                    }
                }
            )
        }
    }

    const deteletPhysicalTake = (data, connection) => {
        data.forEach((id) => {
            deleteElement(connection, model, id).then((response) => {console.log(response)});
        })
    }

    const render = (e, name, physicTakeHeaderCode, charge) => {
        setName(name);
        setPhysicTakeHeaderCode(physicTakeHeaderCode);
        setCharge(charge);
        setState(e);
    }

    function backView(view) {
        render(view, 'Toma Física', '', false);
    }

    return (
        <>
            <IonLoading isOpen={loading} message="Cargando..." />
            <CustomHeader name={name} content={helpContent()} />
            <IonContent scrollY={false}>
                <div className={styles.center}>
                    {state === 'header' && (
                        <PhysicalTakeHeader charge={charge} fn={render} />
                    )}
                    {state === 'detail' && (
                        <PhysicalTakeDetail physicTakeHeaderCode={physicTakeHeaderCode} />
                    )}
                </div>
                {state === 'detail' && (
                    <BackButton fn={backView} value='header' />
                )}
            </IonContent>
        </>
    );
}

export default PhysicalTake;